const SET_MODEL = 'SET_MODEL';
const SET_DISPLAY_CROSS_HAIR = 'SET_DISPLAY_CROSS_HAIR';
const SET_MODELS = 'SET_MODELS';
const RESET = 'RESET';
const FIRST_IDX = 0;

import { getField, updateField } from 'vuex-map-fields';
import ModelService from '@/services/model.service';
import ImageService from '@/services/image.service';
import Constants from '../../constants/Constants';

import i18n from '@/locales/i18n';

export default {
	namespaced: true,

	state() {
		return {
			model: null,
			displayCrossHair: '',
			models: [],
		};
	},

	actions: {
		async retrieveModels({ commit, dispatch }, payload) {
			let response = await ModelService.retrieveModelList({
				user: payload.username,
			});
			let db_models = response.data.db_models;
			let s3BucketUrl = process.env.VUE_APP_S3_BUCKET_URL;
			let cdnCloudFormation = Constants.CDN_CLOUD_FORMATION.thumbnailImage;
			for (let i = 0; i < db_models.length; i++) {
				// get options
				let options = await dispatch("getModelOptions", { modelId: db_models[i]._id.$oid })
				db_models[i].options = options?.data?.opt || {}
				// Retrieve description of model
				let description = db_models[i].description;
				// Check if the model is shared or not shared
				if (description.includes('--- Shared by')) {
					// Retrieve index of "--- Shared by" in description
					let startIndexSubDescription = description.indexOf('--- Shared by');
					// Get content string from "--- Shared by" to end
					let subDescription = description.slice(startIndexSubDescription);
					// Separate description(description of model) and subDescription(sharers)
					db_models[i].subDescription = subDescription;
					db_models[i].description = description.slice(0, startIndexSubDescription);
				}

				if (db_models[i].raw === undefined || db_models[i].result === undefined) {
					continue;
				}

				let image_name = db_models[i].raw.split('/');
				response = await ImageService.getPresignedUrl({
					file_name: image_name.slice(-1)[0],
					s3_key: db_models[i].raw,
				});
				let cdnRawImage = response.data.link.replace(s3BucketUrl, cdnCloudFormation);
				db_models[i].raw = cdnRawImage;

				image_name = db_models[i].result.split('/');
				response = await ImageService.getPresignedUrl({
					file_name: image_name.slice(-1)[0],
					s3_key: db_models[i].result,
				});
				let cdnResultImage = response.data.link.replace(s3BucketUrl, cdnCloudFormation);
				db_models[i].result = cdnResultImage;
			}

			const fistModel = db_models[FIRST_IDX]?.model_name;
			const checkCrossHairModel = db_models[FIRST_IDX]?.display.crosshair;

			commit(SET_MODELS, db_models);
			commit(SET_MODEL, fistModel);
			commit(SET_DISPLAY_CROSS_HAIR, checkCrossHairModel);
		},

		async deleteModel({ commit }, payload) {
			await ModelService.delete(payload);
		},

		async addModelDefault({ commit }, payload) {
			const response = await ModelService.addModelDefault({
				username: payload.username,
				password: payload.password,
				email: payload.email,
			});
			return response;
		},

		setModel({ commit }, payload) {
			commit(SET_MODEL, payload.model);
		},

		resetModels({ commit }) {
			commit(RESET);
		},

		async getSharedModelUser({ commit }, payload) {
			let ressponse = await ModelService.getSharedModelUser(payload);
			return ressponse.data;
		},

		deleteSharedModel({ commit }, payload) {
			return ModelService.deleteSharedModel(payload);
		},

		shareModel({ commit }, { body, allowShareData }) {
			return ModelService.share({ body, allowShareData });
		},

		answerSharingRequest({ commit }, payload) {
			return ModelService.answerSharingRequest(payload);
		},
		async getModelOptions({ commit }, payload) {
			let response = await ModelService.getModelOptions(payload.modelId)
			return response
		},
		async updateModelOptions({ commit }, payload) {
			let response = await ModelService.updateModelOptions(payload.modelId, payload.dict)
			return response
		},
		/**
		 * Update refererence image for one-shot learning
		 * @param {dict} payload The dictionary containing model id, file, bounding box
		 * @returns {Promise}
		 */
		async updateReferenceImage({ commit }, payload) {
			let formData = new FormData();
      formData.append("reference_image", payload.file);
			formData.append("bounding_box", payload.bounding_box);

			let response = await ModelService.updateReferenceImage(payload.modelId, formData)
			return response
		},
		/**
		 * Suggest prompt for model has text prompt
		 * @param {dict} payload The dictionary containing model id, image and gt_cnt
		 * @returns 
		 */
		async suggestPrompt({ commit }, payload) {
			let formData = new FormData();
      formData.append("image", payload.image);
			formData.append("gt_cnt", payload.gt_cnt);

			let response = await ModelService.suggestPrompt(payload.modelId, formData)
			return response
		},
	},

	mutations: {
		updateField,

		SET_MODEL(state, payload) {
			state.model = payload;
		},
		SET_DISPLAY_CROSS_HAIR(state, payload) {
			state.displayCrossHair = payload;
		},

		SET_MODELS(state, payload) {
			state.models = payload;
		},

		RESET(state) {
			state.model = null;
			state.models = [];
		},

		SET_STATE(state, payload) {
			Object.entries(payload).forEach(([key, value]) => {
				state[key] = value;
			});
		},
	},

	getters: {
		getField,
	},
};
